import { SxProps } from "@mui/system";
import React from "react";
import { List, ListItem } from "@mui/material";
import { MuiListNativeStyledStyle } from "./MuiListNativeStyledStyle";

type MuiListNativeStyledProps = {
  sx?: SxProps;
  listItems: Array<String | React.ReactNode>;
  ordered?: boolean;
};

export default function MuiListNativeStyled({ sx = {}, listItems, ordered = false }: MuiListNativeStyledProps) {
  return (
    <List component={ordered ? "ol" : "ul"} sx={{ ...MuiListNativeStyledStyle.list, ...(ordered && { listStyleType: "decimal" }), ...sx }} disablePadding>
      {listItems.map((item, index) => (
        <ListItem key={index} sx={MuiListNativeStyledStyle.listItem} disablePadding>
          {item}
        </ListItem>
      ))}
    </List>
  );
}
